/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import {
  Loader,
  LoginBox,
  LoginFooter,
  LoginWrapper,
  GoBackToLogin,
} from './styles';
import { useHistory } from 'react-router-dom';
import { LeftArrow } from '../../assets/icons/icons';
import loader from '../../assets/lottieFiles/loader.json';

export default ({
  isHistory,
  isLoading,
  children,
  topLoader = 120,
}: {
  isHistory?: boolean,
  isLoading?: boolean,
  topLoader?: number,
  children: JSX.Element | JSX.Element[],
}) => {
  const history = useHistory();

  return (
    <>
      <LoginWrapper>
        <LoginBox>
          {isLoading && (
            <Loader
              loop={true}
              src={loader}
              autoplay={true}
              topLoader={topLoader}
            />
          )}
          {isHistory && (
            <GoBackToLogin onClick={() => history.goBack()}>
              <LeftArrow color="#2B323B" />
            </GoBackToLogin>
          )}
          {children}
        </LoginBox>
      </LoginWrapper>
      <LoginFooter>© 2020 ArmCare.com All Rights Reserved.</LoginFooter>
    </>
  );
};
